import { useSchema } from '../hooks/use-schema';

export const Schema = () => {
    const { getSchemas } = useSchema();

    return getSchemas().map((schema, index) => (
        <script key={index} type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
    ));
};
